const quickAccessData = {
        title: "Quick Access",
        links: [
          {
            label: "View Menu",
            link: "/menu",
            icon: "fa-utensils",
          },
          {
            label: "Book Table",
            link: "#reservation",
            icon: "fa-calendar-alt",
          },
          {
            label: "Private Events",
            link: "/events",
            icon: "fa-glass-cheers",
          },
          {
            label: "Location & Hours",
            link: "/contact",
            icon: "fa-map-marker-alt",
          },
        ],
      };

export default quickAccessData;      